export async function Defer(ms: number) {
    return new Promise(resolve => {
        setTimeout(() => resolve(), ms);
    });
}
